import { useMemo } from "react"
import { PAYLOAD_STATUS_APPROVED, PAYLOAD_STATUS_REJECTED } from "routes/audit/lib/audit-constants.mjs"
import { getDraftAmendsByReferenceIdAndType } from "../../amends/controller/get-draft-amends-by-reference-id-and-type"
import { createDraftId } from "authoring/routes/project/lib/project-utils"
import { AuthoringAmendsType } from "../../../../lib/enum/authoring-amends-type.mjs"
import { buildAmendsReferenceId } from "authoring/routes/project/amends/lib/amends-utils.mjs"
import { resolveRejectionsByAmendsKey } from "./resolve-rejections-by-amends-key"

export function useDraftScheduleReviewDecisionByAmendsKey({ projectId, scheduleId, reviewCycle } = {}) {
    const draftId = createDraftId(projectId, scheduleId)
    const draftReferenceId = draftId ? buildAmendsReferenceId({ id: draftId, reviewCycle: 1 }) : null

    const draftReviewDecisions = getDraftAmendsByReferenceIdAndType.useResultsOnce(
        draftReferenceId,
        AuthoringAmendsType.AUTHORING_AMENDS,
        draftReferenceId
            ? { "payload.status": { $in: [PAYLOAD_STATUS_APPROVED, PAYLOAD_STATUS_REJECTED] } }
            : undefined,
        projectId
    )

    return useMemo(
        () =>
            resolveRejectionsByAmendsKey({
                amends: draftReviewDecisions,
                reviewCycle,
                scheduleId,
            }),
        [draftReviewDecisions, reviewCycle, scheduleId]
    )
}
